// src/components/signage/SignageCalendarStrip.jsx
//
// Compact 7-day programming strip for the Estado tab. Shows which campaigns
// play on each weekday. Extracted from signagepage.js's renderCalendar
// in the Fase 2 refactor; preserves the multi-line per cell behaviour
// (a day with 2+ scheduled campaigns shows them stacked).

import React, { useMemo } from 'react';
import { Tag } from 'antd';
import { argWeekday } from '../../services/signageService';
import './SignageCalendarStrip.css';

const DAY_KEYS = ['lunes', 'martes', 'miercoles', 'jueves', 'viernes', 'sabado', 'domingo'];
const DAY_LABELS = {
    lunes:     'Lun',
    martes:    'Mar',
    miercoles: 'Mié',
    jueves:    'Jue',
    viernes:   'Vie',
    sabado:    'Sáb',
    domingo:   'Dom',
};

// Mirror the schedule encoding in the backend.
const DAY_KEY_TO_WEEKDAY = {
    lunes: 1, martes: 2, miercoles: 3, jueves: 4, viernes: 5, sabado: 6, domingo: 0,
};

function getScheduleForDay(campaigns, dayKey) {
    return campaigns.filter(c => {
        const days = (c.schedule?.days || []).map(s => String(s).toLowerCase());
        if (days.length === 0) return true;  // empty schedule = all days
        return days.includes(dayKey);
    });
}

export default function SignageCalendarStrip({ campaigns = [] }) {
    const todayWd = argWeekday();
    const todayDayKey = useMemo(() => {
        // Reverse-map weekday int → day key for the highlight pill.
        return Object.entries(DAY_KEY_TO_WEEKDAY).find(([, wd]) => wd === todayWd)?.[0] || 'lunes';
    }, [todayWd]);

    return (
        <div className="signage-calendar-strip">
            <h4 className="signage-calendar-strip__title">Programación Semanal</h4>
            <div className="signage-calendar-strip__grid">
                {DAY_KEYS.map(dayKey => {
                    const booked = getScheduleForDay(campaigns, dayKey);
                    const isToday = dayKey === todayDayKey;
                    const hasMany = booked.length > 2;
                    return (
                        <div
                            key={dayKey}
                            className={
                                'signage-calendar-strip__cell '
                                + (booked.length > 0 ? 'has-campaign ' : '')
                                + (isToday ? 'today' : '')
                            }
                        >
                            <div className="day-name">
                                {DAY_LABELS[dayKey]}
                                {isToday && <Tag color="green" className="hoy-pill">HOY</Tag>}
                            </div>
                            {booked.length > 0 ? (
                                <>
                                    {booked.slice(0, 2).map(c => (
                                        <div className="day-campaign" key={c.id}>{c.name}</div>
                                    ))}
                                    {hasMany && (
                                        <div className="day-campaign day-campaign--more">
                                            +{booked.length - 2}
                                        </div>
                                    )}
                                </>
                            ) : (
                                <div className="day-campaign day-campaign--empty">—</div>
                            )}
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
